import { Platform } from 'react-native';

// Master switch for the durable offline outbox (observations only). Web
// ships now — Firestore IndexedDB persistence and a registered SW already
// exist there. Native has no connectivity detection or local persistence
// yet, so it stays off until that lands.
export const OUTBOX_ENABLED = Platform.OS === 'web';
